import { useQuery } from 'react-query'
import axios from 'axios'

const getGruppoSolleciti = async (_: string) => {
  const { data } = await axios.get(`/gruppo-solleciti`)

  return data.results[0]
}

const useGruppoSolleciti = () => {
  return useQuery(['gruppoSolleciti'], () => getGruppoSolleciti('gruppoSolleciti'), {
    refetchInterval: 1000 * 30,
  })
}

export default useGruppoSolleciti
